import { IUpdateObraAreaChecklistUseCase } from "../../../presentation/useCases/update/update_obra_area_checklist_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateObraAreaChecklistUseCase
 */

export class UpdateObraAreaChecklistUseCase implements IUpdateObraAreaChecklistUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateObraAreaChecklist(
    idObraAreaChecklist: number,
    status: number,
    area: string,
    checklists: number[] | null,
  ): Promise<void> {
    await this.repository.updateObraAreaChecklist(
      idObraAreaChecklist,
      status,
      area,
      checklists,
    );
  }
}
